import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SR_API_ACTION_ADMIN_UPDATE_ITEM,
} from 'api/actionTypes';

import {
  validateFormField,
} from 'client/helpers/formikHelpers';

import log from 'client/lib/log';
import postWithState from 'client/actions/postWithState';

class SrUpdateableItemValue extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    table: PropTypes.string.isRequired,
    fieldId: PropTypes.string.isRequired,
    validations: PropTypes.array,
    renderItem: PropTypes.func,
    onItemUpdated: PropTypes.func,
    placeholder: PropTypes.string,
  }

  _onFieldClick = (event) => {
    const {
      item,
      table,
      fieldId,
      validations,
      onItemUpdated,
      dispatch,
    } = this.props;
    event.stopPropagation();

    let newValue = global.prompt(`Please enter a new value for "${fieldId}"`);
    if (typeof newValue === 'object' && !newValue) {
      return;
    }

    const errorMessage = validateFormField({
      validations: validations,
      value: newValue,
    });

    if (errorMessage) {
      global.alert(errorMessage);
      return;
    }

    if (newValue === '') {
      newValue = null;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: table,
        where: {
          id: item.id,
        },
        updates: {
          [fieldId]: newValue,
        },
      },
    })
      .then(() => {
        if (onItemUpdated) {
          return onItemUpdated(item.id);
        }
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const { item, renderItem, fieldId, placeholder } = this.props;
    return (
      <div onClick={this._onFieldClick}>
        {renderItem ? renderItem(item) : (item[fieldId] || placeholder || '')}
      </div>
    );
  }
}

SrUpdateableItemValue.displayName = 'SrUpdateableItemValue';

export default SrUpdateableItemValue;
